// Site-wide product card (snippets/mh-product-card-pt.liquid, pootoo.com style, 2026-09-23).
// Everything is delegated from document, so cards swapped in by AJAX (collection filters, home category tabs) work.
//   · arrows page through the photos (mouse); photo 3+ loads on first use (data-mh-src)
//   · leaving the card resets it to the cover photo
//   · touch: dots follow the swipe
//   · Quick buy fetches /products/<handle>?view=mh-quick-buy once, mounts the <mh-quick-add> dialog
//     (assets/mh-product-card.js) in <body> and opens it; any failure falls back to the product page.
(() => {
  if (window.mhProductCardPt) return;
  window.mhProductCardPt = true;

  const hydrate = (track) => {
    if (track.dataset.mhHydrated) return;
    track.dataset.mhHydrated = 'true';
    track.querySelectorAll('img[data-mh-src]').forEach((img) => {
      img.srcset = img.dataset.mhSrcset || '';
      img.src = img.dataset.mhSrc;
      img.removeAttribute('data-mh-src');
      img.removeAttribute('data-mh-srcset');
    });
  };

  const show = (track, index) => {
    const slides = track.querySelectorAll('.mh-ptcard__slide');
    slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
    track.dataset.index = String(index);
  };

  document.addEventListener('pointerover', (event) => {
    const arrow = event.target.closest?.('[data-mh-ptcard-step]');
    if (arrow) hydrate(arrow.closest('.mh-ptcard__media').querySelector('[data-mh-ptcard-track]'));
  });

  document.addEventListener('click', (event) => {
    const arrow = event.target.closest?.('[data-mh-ptcard-step]');
    if (!arrow) return;
    event.preventDefault();
    const card = arrow.closest('.mh-ptcard');
    const track = card.querySelector('[data-mh-ptcard-track]');
    const count = track.querySelectorAll('.mh-ptcard__slide').length;
    if (count < 2) return;
    hydrate(track);
    // While hovering, photo 2 is already on screen; "next" continues from there instead of re-showing it.
    let current = Number(track.dataset.index || 0);
    if (!track.hasAttribute('data-mh-moved') && card.matches(':hover') && current === 0) current = 1;
    const next = (current + Number(arrow.dataset.mhPtcardStep) + count) % count;
    track.setAttribute('data-mh-moved', '');
    show(track, next);
  });

  document.addEventListener('pointerout', (event) => {
    const card = event.target.closest?.('.mh-ptcard');
    if (!card || card.contains(event.relatedTarget)) return;
    const track = card.querySelector('[data-mh-ptcard-track][data-mh-moved]');
    if (!track) return;
    track.removeAttribute('data-mh-moved');
    show(track, 0);
  });

  // Touch swipe: load the remaining photos as soon as the finger lands, move the dots with the scroll.
  document.addEventListener('touchstart', (event) => {
    const track = event.target.closest?.('[data-mh-ptcard-track]');
    if (track) hydrate(track);
  }, { passive: true, capture: true });

  document.addEventListener('scroll', (event) => {
    const track = event.target;
    if (!(track instanceof HTMLElement) || !track.matches('[data-mh-ptcard-track]')) return;
    hydrate(track);
    const index = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    track.closest('.mh-ptcard__media').querySelectorAll('.mh-ptcard__dot').forEach((dot, i) => dot.classList.toggle('is-active', i === index));
  }, { capture: true, passive: true });

  // Quick buy
  const mounted = new Map();
  document.addEventListener('click', async (event) => {
    const button = event.target.closest?.('[data-mh-quick-buy]');
    if (!button) return;
    event.preventDefault();
    const url = button.dataset.mhQuickBuy;
    const fallback = () => window.location.assign(button.dataset.mhProductUrl);
    if (!customElements.get('mh-quick-add')) { fallback(); return; }
    if (button.getAttribute('aria-busy') === 'true') return;
    let dialog = mounted.get(url);
    if (!dialog?.isConnected) {
      button.setAttribute('aria-busy', 'true');
      document.dispatchEvent(new CustomEvent('mh:busy', { detail: { source: 'quick-buy' } }));
      try {
        const response = await fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error(`Quick buy ${response.status}`);
        const template = document.createElement('template');
        template.innerHTML = (await response.text()).trim();
        dialog = template.content.querySelector('mh-quick-add');
        if (!dialog) throw new Error('Quick buy returned no dialog');
        document.body.append(dialog);
        mounted.set(url, dialog);
      } catch (error) {
        fallback();
        return;
      } finally {
        button.removeAttribute('aria-busy');
        document.dispatchEvent(new CustomEvent('mh:idle', { detail: { source: 'quick-buy' } }));
      }
    }
    if (typeof dialog.open === 'function') dialog.open(button);
    else fallback();
  });
})();
